import { EventMeta } from '../../../interfaces/meta.interface';
import { getTransportRule } from './New-TransportRule';

type EnableTransportRuleDescFields = {
    name: string;
};

const EnableTransportRule: EventMeta<EnableTransportRuleDescFields> = {
    title: 'Transport Rule Enabled',
    default: {
        description: 'Transport Rule Enabled',
        longDescription: 'A Transport Rule was enabled.',
        severity: 'info',
    },
    descriptionExtractor: (log: any) => ({
        name: log.name,
    }),
    classifications: getTransportRule('enabled'),
};

export default EnableTransportRule;
